import { Node, Transforms } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

const layoutUtilities = serializer.utilities.node.layout;

// Settings by breakpoint (spec 3.10). Desktop writes the base values; Tablet and Mobile write
// overrides, and resetting one deletes the key so the inherited value shows again.

function cloneValue(value) {
  return JSON.parse(JSON.stringify(value));
}

function writeAt(stored, breakpoint, changes) {

  if (breakpoint === 'desktop') {
    return { ...stored, ...changes };
  }

  return { ...stored, [breakpoint]: { ...(stored[breakpoint] || {}), ...changes } };

}

function resetAt(stored, breakpoint, keys) {

  const overrides = { ...(stored[breakpoint] || {}) };

  for (let index = 0; index < keys.length; index++) {
    delete overrides[keys[index]];
  }

  return { ...stored, [breakpoint]: overrides };

}

function readOverrides(stored, breakpoint) {

  if (breakpoint === 'desktop') {
    return {};
  }

  return stored[breakpoint] || {};

}

// What renders at a breakpoint and which keys that breakpoint overrides.
export function readLayoutBreakpoint(node, breakpoint) {

  return {
    values: layoutUtilities.resolveSettings(node)[breakpoint],
    overrides: readOverrides(layoutUtilities.getSettings(node), breakpoint)
  };

}

export function writeLayoutSettings(node, breakpoint, changes) {
  return writeAt(cloneValue(layoutUtilities.getSettings(node)), breakpoint, changes);
}

export function resetLayoutSettings(node, breakpoint, keys) {
  return resetAt(cloneValue(layoutUtilities.getSettings(node)), breakpoint, keys);
}

export function saveLayoutSettings(editor, path, settings) {

  const node = Node.get(editor, path);

  Transforms.setNodes(editor, { properties: { ...node.properties, layout: layoutUtilities.sanitizeSettings(settings) } }, { at: path });

}

export function readItemBreakpoint(layoutNode, child, breakpoint) {

  const resolvedLayout = layoutUtilities.resolveSettings(layoutNode);

  return {
    values: layoutUtilities.resolveItemSettings(resolvedLayout, child)[breakpoint],
    overrides: readOverrides(layoutUtilities.getItemSettings(child) || {}, breakpoint),
    layout: resolvedLayout[breakpoint]
  };

}

export function writeItemSettings(child, breakpoint, changes) {
  return writeAt(cloneValue(layoutUtilities.getItemSettings(child) || {}), breakpoint, changes);
}

export function resetItemSettings(child, breakpoint, keys) {
  return resetAt(cloneValue(layoutUtilities.getItemSettings(child) || {}), breakpoint, keys);
}

export function saveItemSettings(editor, path, itemSettings) {

  const properties = { ...Node.get(editor, path).properties };
  const sanitized = layoutUtilities.sanitizeItemSettings(itemSettings);

  delete properties.layoutItem;

  if (sanitized !== null && Object.keys(sanitized).length > 0) {
    properties.layoutItem = sanitized;
  }

  Transforms.setNodes(editor, { properties }, { at: path });

}

// Size in layout: Fill takes a weight, Fit content sizes to the content, Fixed takes px or %.
export function readItemSize(values) {

  if (values.grow > 0) {
    return { mode: 'fill', weight: values.grow, basis: null };
  }

  if (values.basis === 'auto') {
    return { mode: 'fit', weight: null, basis: null };
  }

  return { mode: 'fixed', weight: null, basis: values.basis };

}

export function buildItemSize(mode, amount) {

  if (mode === 'fill') {
    return { grow: amount, shrink: 1, basis: '0%' };
  }

  if (mode === 'fit') {
    return { grow: 0, shrink: 1, basis: 'auto' };
  }

  return { grow: 0, shrink: 0, basis: amount };

}
